module.exports = __webpack_public_path__ + "static/antd-datepicker-range-ba16ac4c6735856999b45148247f2a27.gif";